import React from 'react';
import { Navigate } from 'react-router-dom';
import { CircularProgress, Container } from '@mui/material';
import { useUserPermissions } from '../hooks/useUserPermissions';

interface AccountingRouteProps {
  children: React.ReactNode;
}

/**
 * AccountingRoute component that checks for accounting permissions
 * Accepts: accounting.view, accounting.all, or accounting.admin
 * Redirects unauthorized users to access denied page
 */
export const AccountingRoute: React.FC<AccountingRouteProps> = ({ children }) => {
  const { hasPermission, isLoading } = useUserPermissions();

  if (isLoading) {
    return (
      <Container
        maxWidth="xl"
        sx={{ py: 4, minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <CircularProgress />
      </Container>
    );
  }

  // Check if user has any accounting permission (view, all, or admin)
  const hasAccountingPermission =
    hasPermission('accounting.view') ||
    hasPermission('accounting.all') ||
    hasPermission('accounting.admin');

  if (!hasAccountingPermission) {
    return <Navigate to="/access-denied" replace />;
  }

  return <>{children}</>;
};